export const usePdfDownloader = () => {
  /**
   * 💾 Descarga un PDF en base64 con un nombre dinámico.
   *
   * @param dataUrl  PDF codificado en base64 (puede o no incluir prefijo data:)
   * @param fileName Nombre del archivo (ej: "ABC123.pdf")
   */
  const downloadBase64Pdf = (dataUrl: string, fileName = 'documento.pdf') => {
    if (!dataUrl || typeof dataUrl !== 'string') {
      console.warn('⚠️ No se puede descargar: el archivo base64 está vacío o es inválido');
      return;
    }

    try {
      const normalizedDataUrl = dataUrl.startsWith('data:application/pdf')
        ? dataUrl
        : `data:application/pdf;base64,${dataUrl}`;

      const link = document.createElement('a');
      link.href = normalizedDataUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('❌ Error al intentar descargar el PDF:', error);
    }
  };

  return { downloadBase64Pdf };
};
